<template>
  <div>
    <!-- 批量导入 -->
    <el-dialog
      width="500px"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      v-if="importVisible"
      :visible.sync="importVisible"
      title="导入"
    >
      <el-form
        ref="addForm"
        :model="addForm"
        :rules="addFormRules"
        label-width="100px"
      >
        <el-form-item label="数据导入：" prop="file">
          <el-upload
            ref="uploadEl"
            class="upload-demo"
            action
            :auto-upload="false"
            accept=".xls,.xlsx"
            :on-change="onFileChange"
            :http-request="upload"
            :file-list="fileList"
          >
            <el-button size="small" type="success" slot="trigger">选择EXCEL</el-button>
            <!-- <span class="upload-tip">(包含批次号、产品编号列即可)</span> -->
            <div style="text-align: left;">
              <el-link type="primary" :underline="false" @click="downloadTemplate">下载模板</el-link>
            </div>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="importVisible = false">取消</el-button>
        <el-button type="success" @click="confirm">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      importVisible: false,
      addForm: {
        file: "",
      },
      addFormRules: {
        file: [
          { required: true, message: "导入文件不能为空", trigger: "blur" },
        ],
      },
      fileList: [],
      fullLoading: null,
    }
  },
  mounted() {

  },
  methods: {
    importProduct() {
      this.addForm.file = "";
      this.fileList = [];
      this.importVisible = true;
    },
    confirm() {
      this.$refs.addForm.validate((valid) => {
        if (!valid) return;

        this.$refs.uploadEl.submit();
      });
    },
    onFileChange(file) {
      if (file) {
        this.addForm.file = file.name;
        this.fileList = [file];
      }
    },
    upload({ file }) {
      this.showLoading();
      let taskDTO = {
        reportName: 'reviewProductImport',
        appCode: "soft-vote-web",
        paramMap: []
      };
      let formData = new FormData();
      formData.append('file', file);
      formData.append('taskDTO', JSON.stringify(taskDTO))
      this.$q.excelConfig.import(formData)
        .then(({ code, message, data }) => {
          const isSuccess = code === 200;
          this.showResult(isSuccess, message);

          if (isSuccess) {
            this.importVisible = false;
            this.$emit('onsuccess', null);
          }
        })
        .finally(() => {
          this.closeLoading();
        });
    },
    showResult(isSuccess = true, message) {
      if (isSuccess) {
        this.$notify.success({
          title: "成功",
          message: `评审产品导入成功！`,
        });
      } else {
        this.$notify.error({
          title: "错误",
          message,
        });
      }
    },
    showLoading() {
      this.closeLoading();

      this.fullLoading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
      });
    },
    closeLoading() {
      if (this.fullLoading) {
        this.fullLoading.close();
      }
    },
    downloadTemplate() {
      this.$q.excelConfig.downloadTemplate({reportName: 'reviewProductImport'})
      .then(res=>{
        this.downLoad(res.data.templatePath, res.data.fileName);
      })
    },
    downLoad(url, name) {
      this.downLoadLink(url, name);
    },
    downLoadLink(filePath,fileName) {
      var xhr = new XMLHttpRequest();
      xhr.open("GET", filePath, true);
      xhr.responseType = "blob";
      xhr.onload = function() {
        if (xhr.status === 200) {
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(xhr.response, fileName);
          } else {
            var link = document.createElement("a");
            var body = document.querySelector("body");

            link.href = window.URL.createObjectURL(xhr.response);
            link.download = fileName;

            // fix Firefox
            link.style.display = "none";
            body.appendChild(link);

            link.click();
            body.removeChild(link);
            window.URL.revokeObjectURL(link.href);
          }
        }
      };
      xhr.send();
    }
  }
}
</script>

<style>

</style>